import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		text: {
			textAlign: ({ alignment }) => alignment?.metaValue,

			[theme.breakpoints.down('xs')]: {
				textAlign: ({ mobileAlignment }) => mobileAlignment?.metaValue || null,
			},
		},
		grid: {
			margin: theme.spacing(-2.5, -4),
			width: `calc(100% + ${theme.spacing(8)})`,
			justifyContent: ({ alignment }) => alignment?.contentAlignment(),
		},

		gridItem: {
			padding: theme.spacing(2.5, 4),
		},

		buttonWrap: {
			width: '100%',
			display: 'flex',
			'&:not(:first-child)': {
				marginTop: theme.spacing(3),
			},
			justifyContent: ({ alignment }) => alignment?.contentAlignment(),

			[theme.breakpoints.down('xs')]: {
				justifyContent: ({ mobileAlignment }) => mobileAlignment?.contentAlignment(null),
			},
		},

		button: {
			width: 'auto',

			[theme.breakpoints.down('xs')]: {
				width: ({ mobileButtonWidth }) => (mobileButtonWidth?.isWide ? '100%' : 'auto'),
			},
		},
	}),
	{ name: 'FAQ-Additional-Text' },
)

export default useStyles
